const TemplateCard = ({ template, languageMap, onCardClick }) => {
  return (
    <div
      className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition duration-200 cursor-pointer"
      onClick={() => onCardClick(template)}
    >
      <div className="p-4 space-y-3">
        <h3 className="text-lg font-semibold text-gray-900 truncate">{template.templateName}</h3>
        <div className="grid grid-cols-1 gap-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Category:</span>
            <span className="text-gray-900">{template.category}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Language:</span>
            <span className="text-gray-900">{languageMap[template.language] || template.language}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Header Type:</span>
            <span className="text-gray-900">{template.headerType || "-"}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Created:</span>
            <span className="text-gray-900">{new Date(template.createdAt).toLocaleDateString()}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Status:</span>
            <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium capitalize ${
              template.status === "pending"  ? "bg-yellow-100 text-yellow-800" :
              template.status === "rejected" ? "bg-red-100 text-red-800" :
              template.status === "approved" ? "bg-blue-100 text-blue-800" :
              "bg-green-100 text-green-800"
            }`}>
              {template.status || "Pending"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
